<template>
  <div>
    <Form :isSubmitting="isSubmitting" @submit="storeData" />
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import Form from '../shared/Form'
// eslint-disable-next-line import/no-cycle
import useRoleAdd from './useRoleAdd'

export default {
  components: {
    Form,
  },
  setup() {
    const { storeData, isSubmitting } = useRoleAdd()

    return {
      storeData,
      isSubmitting,
    }
  },

}
</script>
